(ns rothko.icon.component
  (:require [rothko.icon.core :refer [svg-icons-html]]
            [taoensso.timbre :as timbre]))

(defn svg-sprite []
  [:div.icons
   {:style {:display :none}
    :dangerouslySetInnerHTML {:__html svg-icons-html}}])

(def icon-names
  #{:angle-up
    :angle-down
    :angle-up-and-down
    :arrow-up
    :bars
    :bin
    :book
    :copy
    :cross
    :document-add
    :expand
    :eye
    :filter
    :graph
    :history
    :info
    :list-ul
    :lock
    :message
    :microphone
    :pause
    :play
    :redo
    :sign-in
    :sign-out
    :spinner
    :split
    :questions
    :tick
    :undo
    :unlocked
    :user
    :volume-off
    :volume-up
    :warning})

(defn icon
  [{:keys [class desc height icon on-click size style title width]
    :as   _props
    :or   {size 16}}]
  (let [attrs     {:class    class
                   :style    style
                   :on-click on-click}
        icon-name (name icon)
        width     (or width size)
        height    (or height size)]
    (if (contains? icon-names icon)
      [:svg.icon (merge-with into attrs {:aria-hidden     (= title icon-name)
                                         :aria-labelledby (str title " " desc)
                                         :height          height
                                         :width           width
                                         :role            :img})
       [:title (or title icon-name)]
       [:desc desc]
       ;; Width and height attributes required to display in firefox
       [:use {:height    height
              :width     width
              :xlinkHref (str "#icon-" icon-name)}]]
      (do
        (timbre/warn (str "Icon " icon " does not exist in icon-names set in rothko.icon.component"))
        [:span]))))
